module.exports = "/_next/static/resources/pack-097629d189947213d0da28a6417285bd.webp";